import { Tooltip, Typography, useTheme } from '@mui/material';
import { formatNumberDE } from '../../../../../../shared/utils/formatNumber';
import { scenarioDeltaTextSx } from '../../../../../../shared/utils/scenarioHighlight';

/**
 * Renders the vessel capacity ("First Shipping Line Offer") figure. When the
 * per-destination totals it was resolved from are inconsistent, the value is
 * shown in red with a tooltip note explaining how it was calculated.
 */
const VesselCapacityValue = ({
  value,
  isError,
  note,
  variant = 'body1',
  highlighted = false,
}) => {
  const theme = useTheme();

  const content = (
    <Typography
      variant={variant}
      sx={
        isError
          ? { color: theme.palette.error.main, cursor: 'help' }
          : highlighted
            ? scenarioDeltaTextSx(theme)
            : undefined
      }
    >
      {formatNumberDE(value)}
    </Typography>
  );

  if (isError && note) {
    return (
      <Tooltip title={note} arrow placement='top'>
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default VesselCapacityValue;
